import { ForumError, forumEnvelope, forumError, invalidResponse, staleResponse } from './forumErrors';
import { forumId } from '../models/forumMappers';

export function createForumDeleteRepository({ http, getIdentity, invalidate = () => {} }) {
  const flights = new Map(), identity = () => JSON.stringify(getIdentity() || {});
  return {
    remove(threadId, post) {
      const nid = forumId(threadId), id = forumId(post && post.id), type = post && post.type;
      if (!nid || !id || !['topic', 'comment'].includes(type) || type === 'topic' && id !== nid) return Promise.reject(invalidResponse());
      if (!forumId((getIdentity() || {}).uid)) return Promise.reject(staleResponse());
      const owner = identity(), key = owner + ':' + nid + ':' + type + ':' + id;
      if (flights.has(key)) return flights.get(key);
      const current = () => { if (identity() !== owner) throw staleResponse(); };
      const evict = () => { try { invalidate(['thread:' + nid, 'topics', 'search', 'activity']); } catch (_) { /* A cache error cannot undo a server write. */ } };
      const request = Promise.resolve().then(() => { current(); return http.post('/forum/api/v2/posts/delete', { thread_id: nid, entity_type: type === 'topic' ? 'node' : 'comment', entity_id: id }); }).then(response => {
        current(); const data = forumEnvelope(response.data).data;
        if (forumId(data.thread_id) !== nid || forumId(data.post_id) !== id || data.post_type !== type || data.deleted !== true) throw invalidResponse();
        evict(); return { threadId: nid, postId: id, postType: type, deleted: true };
      }).catch(error => {
        current(); evict(); // Returning via another route must also read fresh state.
        const failure = forumError(error);
        if ((!failure.status && failure.code !== 'stale_response') || failure.status >= 500) throw new ForumError('delete_uncertain', 'No se pudo confirmar el borrado. Comprueba el estado del mensaje antes de continuar.', failure.status);
        if (failure.status === 403 && failure.code !== 'csrf_invalid') throw new ForumError('delete_denied', 'No tienes permiso para eliminar este mensaje.', 403);
        throw failure;
      }).finally(() => { if (flights.get(key) === request) flights.delete(key); });
      flights.set(key, request); return request;
    }
  };
}
